import React, { useEffect, useState } from "react";
import { styled, } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import { Search } from "@mui/icons-material";

const SearchContainer = styled("div")(({ theme }) => {
  const isDark = document.body.classList.contains("bg-dark");
  return {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
  // backgroundColor: alpha(theme.palette.common.white, 0.15),
  // '&:hover': {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    transition: "all 0.2s ease-in-out",
    borderColor: isDark ? "rgba(255, 255, 255, 0.2) !important" : undefined,
    "&:focus-within": {
      boxShadow: isDark
        ? "0 0 0 0.1rem rgba(255, 255, 255, 0.2)"
        : "0 0 0 0.1rem rgba(223, 223, 223, 1)",
    },
  };
});

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  marginLeft: theme.spacing(1),
  flex: 1,
})); 

const SearchBar = ({ placeholder, searchTerm, onSearchChange }) => {
  return (
    <SearchContainer className="border border-1 rounded-pill me-2">
      <StyledInputBase
        placeholder={placeholder || "Search..."}
        value={searchTerm}
        onChange={onSearchChange}
      />
      <IconButton sx={{ color: "rgba(18, 183, 159, 1)" }}>
        <Search />
      </IconButton>
    </SearchContainer>
  );
};

export default SearchBar;

export const useDebounce = (inputValue,delay=500) => {
  const [debounceValue, setDebounceValue] = useState(inputValue);
  useEffect(() => {
    const timer = setTimeout(() => setDebounceValue(inputValue), delay);
    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, delay]);
  return debounceValue
}